// extracted by mini-css-extract-plugin
module.exports = {"content":"_2ddqEofa flex flex-auto flex-column","items":"_1e7Sa6w6 flex flex-auto flex-column justify-start"};